/* Auto-generated — run: npm run build:pembury-progress */

import type { ProgressCarouselItem } from '../components/ProgressStageCarousel';

export type PemburyProgressStage = {
  date: string;
  title: string;
  items: ProgressCarouselItem[];
};

export const PEMBURY_PROGRESS_STAGES: PemburyProgressStage[] = [
  {
    "date": "March 2026",
    "title": "Ecological Enhancement and Planting",
    "items": [
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/000.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 1 of 10"
      },
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/001.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 2 of 10"
      },
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/002.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 3 of 10"
      },
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/003.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 4 of 10"
      },
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/004.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 5 of 10"
      },
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/005.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 6 of 10"
      },
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/006.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 7 of 10"
      },
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/007.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 8 of 10"
      },
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/008.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 9 of 10"
      },
      {
        "src": "/progress/pembury/02-ecological-enhancement-and-planting/009.jpg",
        "type": "image",
        "alt": "Ecological Enhancement and Planting, photo 10 of 10"
      }
    ]
  },
  {
    "date": "October 2025",
    "title": "Tree Clearance",
    "items": [
      {
        "src": "/progress/pembury/01-tree-clearance/000.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 1 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/001.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 2 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/002.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 3 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/003.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 4 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/004.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 5 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/005.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 6 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/006.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 7 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/007.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 8 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/008.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 9 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/009.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 10 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/010.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 11 of 12"
      },
      {
        "src": "/progress/pembury/01-tree-clearance/011.jpg",
        "type": "image",
        "alt": "Tree Clearance, photo 12 of 12"
      }
    ]
  }
];
